<template>
    <article class="teaser teaser-vacancy">
        <div class="teaser-vacancy__inner">
            <div class="teaser-vacancy__body">
                <div class="teaser-vacancy__company-logo" v-if="company_logo">
                    <img :src="company_logo" alt="Logo bedrijf">
                </div>
                <h2 class="heading--4 teaser-vacancy__title"><a :href="link" class="teaser__title-link" :html="formattedTitle">{{ formattedTitle }}</a></h2>
                <div class="teaser-vacancy__meta">
                    <div class="teaser-vacancy__meta-location" v-if="location">{{ location }}</div>         
                    <div class="teaser-vacancy__meta-jobhours" v-if="jobHours">{{ jobHours }} uur</div>
                    <template v-if="this.educations.length">
                        <div class="teaser-vacancy__meta-education" v-for="education in educations">
                            {{ education }}
                        </div>
                    </template>
                </div>
                <div class="teaser-vacancy__text" v-html="excerpt"></div>
                <div class="teaser-vacancy__meta-date" v-if="date">{{ getDaysFrom(date)}} geleden geplaatst</div>
            </div>
        </div>
    </article>
</template>
<script>

import { createDateFilter } from "vue-date-fns";
import { formatDistanceStrict }  from 'date-fns';
import locale from "date-fns/locale/nl";

import { store } from './store.js';
import Icon from './Icon.vue';

export default {
    name: 'VacancyTeaser',
    props: [
        'title',
        'link',
        'excerpt',
        'date',
        'location',
        'salary',
        'jobHours',
        'company_logo',
        'terms'
    ],
    filters: {
        date: createDateFilter("dd MMMM yyyy", { locale })
    },
    data() {
        return {
            store,
            educations: [],
        }
    },
    computed: {
        formattedTitle() {
            const parser = new DOMParser();
            const decodedTitle = parser.parseFromString(`<!doctype html><body>${this.title}`, 'text/html').body.textContent;
            return decodedTitle.replace('&amp;', '&');
        }
    },
    components: {
        Icon
    },
    mounted: function() {
        if(this.terms.length) {
            this.terms.forEach((element) => this.getEducation(element));
        }
    },
    methods: {
        getDaysFrom(date) {
            const now = new Date();
            const distance = formatDistanceStrict(new Date(date), now, { locale});
            return distance;
        },
        getEducation(terms) {
                    
            terms.forEach((term) => {
                if(term.taxonomy == 'education') {
                    this.educations.push(term.name);
                }
            });
        }
    }
};
</script>